export const T = {
  en_GB: {
    returnsIn: (currency: string | null) =>
      `Returns ${currency ? `in ${currency} ` : ""}from month-end prices`,
    returnsInStored: (currency: string | null) =>
      `Returns ${currency ? `in ${currency} ` : ""}from stored month-end prices, no patch or conversion`,
    trailingTo: (date: string) => `trailing returns to ${date}`,
    toLatestPrice: "YTD and month to date to the latest price",
    toLastPrice: (date: string) =>
      `no new prices since ${date}, so the statistics end there and there is no year or month to date`,
    asOfDate: (p: { day: number; month: string; year: number }) => `${p.day} ${p.month} ${p.year}`,
    ytd: "YTD",
    mtd: "Month to date",
    oneYear: "1 year",
    yearsPa: (n: number) => `${n} years p.a.`,
    sinceStartPa: "Since start p.a.",
    sinceStart: "Since start",
    bestMonth: "Best month",
    worstMonth: "Worst month",
    bestYear: "Best year",
    worstYear: "Worst year",
    noFullYear: "no full year yet",
    months: "Months",
    quarters: "Quarters",
    returnsInPct: "Returns in %.",
    returnsInPctQuarters: "Returns in %, each quarter compounded from its months.",
    quarterYear: (p: { quarter: number; year: number }) => `Q${p.quarter} ${p.year}`,
    partialBoth: (p: {
      toDate: string;
      unit: "month" | "quarter" | "year";
      start: string;
      ending: "toDate" | "lastPrice";
    }) =>
      `* Partial: ${p.toDate} ${p.ending === "lastPrice" ? "runs to the last price" : `is ${p.unit} to date`}, and the history starts in ${p.start}.`,
    partialToDate: (p: {
      toDate: string;
      unit: "month" | "quarter" | "year";
      ending: "toDate" | "lastPrice";
    }) =>
      `* Partial: ${p.toDate} ${p.ending === "lastPrice" ? "runs to the last price" : `is ${p.unit} to date`}.`,
    partialStart: (start: string) => `* Partial: the history starts in ${start}.`,
    noMonths: "Not enough history for monthly returns yet.",
  },
  nb_NO: {
    returnsIn: (currency: string | null) =>
      `Avkastning ${currency ? `i ${currency} ` : ""}fra månedsslutt-kurser`,
    returnsInStored: (currency: string | null) =>
      `Avkastning ${currency ? `i ${currency} ` : ""}fra lagrede månedsslutt-kurser, uten patch eller valutaomregning`,
    trailingTo: (date: string) => `periodeavkastning til ${date}`,
    toLatestPrice: "hittil i år og hittil i måneden til siste kurs",
    toLastPrice: (date: string) =>
      `ingen nye kurser siden ${date}, så statistikken slutter der, uten hittil i år og hittil i måneden`,
    asOfDate: (p: { day: number; month: string; year: number }) => `${p.day}. ${p.month} ${p.year}`,
    ytd: "Hittil i år",
    mtd: "Hittil i måneden",
    oneYear: "1 år",
    yearsPa: (n: number) => `${n} år p.a.`,
    sinceStartPa: "Siden start p.a.",
    sinceStart: "Siden start",
    bestMonth: "Beste måned",
    worstMonth: "Verste måned",
    bestYear: "Beste år",
    worstYear: "Verste år",
    noFullYear: "ingen hele år ennå",
    months: "Måneder",
    quarters: "Kvartaler",
    returnsInPct: "Avkastning i %.",
    returnsInPctQuarters: "Avkastning i %, hvert kvartal sammensatt av sine måneder.",
    quarterYear: (p: { quarter: number; year: number }) => `K${p.quarter} ${p.year}`,
    partialBoth: (p: {
      toDate: string;
      unit: "month" | "quarter" | "year";
      start: string;
      ending: "toDate" | "lastPrice";
    }) =>
      `* Delvis: ${p.toDate} ${p.ending === "lastPrice" ? "går til siste kurs" : `er hittil i ${p.unit === "quarter" ? "kvartalet" : p.unit === "year" ? "året" : "måneden"}`}, og historikken starter i ${p.start}.`,
    partialToDate: (p: {
      toDate: string;
      unit: "month" | "quarter" | "year";
      ending: "toDate" | "lastPrice";
    }) =>
      `* Delvis: ${p.toDate} ${p.ending === "lastPrice" ? "går til siste kurs" : `er hittil i ${p.unit === "quarter" ? "kvartalet" : p.unit === "year" ? "året" : "måneden"}`}.`,
    partialStart: (start: string) => `* Delvis: historikken starter i ${start}.`,
    noMonths: "Ikke nok historikk for månedsavkastning ennå.",
  },
} as const;
